/* ───────────────────── MAGIC LINK HELPERS ───────────────────── */
export function buildMagicLink(teamId, passcode) {
  const base = window.location.origin + window.location.pathname;
  return base + "?t=" + encodeURIComponent(teamId) + "&code=" + encodeURIComponent(passcode);
}

/* qrUrl() is GONE ON PURPOSE. It built a quickchart.io URL with the magic link
   — passcode and all — as a query parameter, so every render shipped a working
   credential to a third party. Use the <QrCode> component instead; it renders
   locally and the passcode never leaves the browser. */
